import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';
import JsLogo from '../Images/jsLogo';
import ReactLogo from '../Images/ReactLogo';
import NodeLogo from '../Images/node';
import LogoHtml from '../Images/LogoHtml';
import CSSLogo from '../Images/CSSLogo';
import ExpressLogo from '../Images/ExpressLogo';
import MongoLogo from '../Images/MongoLogo';
import Angular from '../Images/Anuglar';
import Next from '../Images/Next';
import Mysql from '../Images/Mysql';

function IndividualIntervalsExample() {
  return (
    <Carousel>
      <Carousel.Item interval={3000}>
        <LogoHtml />
   
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <CSSLogo />
     
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <JsLogo />
      
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <ReactLogo />

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <Angular /> 
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <Next />  
       
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <NodeLogo />
    
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <ExpressLogo />
    
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <MongoLogo />

        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={3000}>
        <Mysql />
        <Carousel.Caption></Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default IndividualIntervalsExample;
